export const PAGE_ID = '107475507666954';

export const FB_LOCALE = {
  'en': 'en_US',
  'ko': 'ko_KR',
}